import * as React from "react";
import { Input } from "./widget";
import { bind, Control, ControlProps } from "./Control";

const PhoneInput = (props: ControlProps) => {

    const id = props.name;
    const binding = bind(props);

    const onChange = (e: React.ChangeEvent<any>) => {
        if (/^-?[+]?[\d, ]*$/.test(e.currentTarget.value)) {
            binding.onChange(e.currentTarget.value);
        }
    }

    return <Control {...props}>
        <Input
            autoFocus={props.autoFocus}
            name={id}
            id={id}
            placeholder={props.placeholder}
            value={binding.value ?? ''}
            onChange={onChange} />
    </Control>;
}

export {
    PhoneInput
};